var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 0.345703H19.2664L12.5664 7.25513L20.4492 16.6588H14.2778L9.44065 10.9567L3.91208 16.6588H0.842076L8.00779 9.26599L0.449219 0.346989H6.77779L11.1435 5.55799L16.1992 0.345703ZM15.1206 15.0028H16.8206L5.84922 1.91556H4.02636L15.1206 15.0028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconWhite);
export default __webpack_public_path__ + "static/media/x_icon_white.dccb6f30c95bb9fe494d6d0f3e085096.svg";
export { ForwardRef as ReactComponent };